module.exports = __webpack_public_path__ + "static/img/2d.b90e87e7.jpg";